module.exports = __webpack_public_path__ + "static/media/kr.472436a2.svg";